import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatPaginator } from '@angular/material/paginator';
import { SeasonBagNewModalComponent } from './season-bag-new-modal/season-bag-new-modal.component';

import { MatDialog } from '@angular/material/dialog';
import { Data2Service } from '../common/data2.service';
import { DataBagService } from '../common/data-bag.service';
import { DateService } from '../common/date.service';
import { InfoboxService } from '../common/infobox/infobox.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionService } from '../common/question-dialog/question-dialog.service';
import { LoaderService } from '../common/loader/loader.service';
import { SeasonBagNewModalStatusChangeComponent } from './season-bag-new-modal-status-change/season-bag-new-modal-status-change.component';

@Component({
	selector: 'app-season-bag-new',
	templateUrl: './season-bag-new.component.html',
	styleUrls: ['./season-bag-new.component.css'],
})
export class SeasonBagNewComponent extends ListComponent implements AfterViewInit {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	protected apiType = 'bag';
	protected apiUrl = 'transport/transport_term';
	showTable = true;
	matData = new MatTableDataSource<any>();
	protected itemsBeforeDataLoad = 0;
	protected filterValue = '';
	protected lastClickedIndex = null;
	filters;
	action_term = true;
	stop_sale = false;
	protected statuses = [
		{ value: 100, viewValue: '100%' },
		{ value: 75, viewValue: '75%' },
		{ value: 50, viewValue: '50%' },
		{ value: 25, viewValue: '25%' },
		{ value: 0, viewValue: '0%' },
	];

	parameters = {
		yesno: [
			{ name: 'Tak', value: 'true' },
			{ name: 'Nie', value: 'false' },
		],
		names: [],
		statuses: [
			{ value: 100, viewValue: '100%' },
			{ value: 75, viewValue: '75%' },
			{ value: 50, viewValue: '50%' },
			{ value: 25, viewValue: '25%' },
			{ value: 0, viewValue: '0%' },
		],
	};

	private readonly weekday = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];

	displayedColumns: string[] = [
		'id',
		'name',
		'departureTime',
		'accommodationFrom',
		'accommodationTo',
		'returnTime',
		'departure',
		'return',
		'accomodation',
		'status',
		'tourisGuides',
		'confirmTime',
		'swinging',
		'button',
	];

	constructor(
		protected dialog: MatDialog,
		protected api: Data2Service,
		protected bag: DataBagService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected question: QuestionService,
		protected loader: LoaderService,
	) {
		super(api, bag, date, infobox, route, router, question, loader);
	}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	protected loadBefore() {
		this.bag.get('/transport/transport_term_name/?limit=999', (result, error) => {
			this.parameters.names = result.results;
			this.loadData();
		});
	}

	protected convertData(result) {
		result.results.forEach((obj) => {
			obj.departure = obj.departureTime ? this.dateFormatT(obj.departureTime) : '';
			obj.departureDay = obj.departure ? this.getWeekday(obj.departure) : '';
			obj.accommodationFrom = obj.accommodation.lower;
			obj.accommodationFromDay = this.getWeekday(obj.accommodationFrom);
			obj.accommodationTo = obj.accommodation.upper;
			obj.accommodationToDay = this.getWeekday(obj.accommodationTo);
			obj.return = obj.returnTime ? this.dateFormatT(obj.returnTime) : '';
			obj.returnDay = obj.returnTime ? this.getWeekday(obj.return) : '';
			obj.tourisGuide = 'Jan Nowak';
			obj.swinging = obj.swinging == true ? 'Tak' : 'Nie';
			obj.color = this.getColor(obj.status);
		});
		this.matData.data = result.results;
	}

	private getColor(status) {
		switch (status) {
			case 100:
				return 'green';
			case 75:
				return 'blue';
			case 50:
				return 'white';
			case 25:
				return 'gray';
			case 0:
				return 'red';
		}
		return 'white';
	}

	private dateFormatT(date: string): string {
		return date.split('T')[0];
	}

	private getWeekday(date) {
		const dateObj = new Date(date);
		return this.weekday[dateObj.getDay()];
	}
	protected selectAll(event) {
		this.matData.filteredData.forEach((row) => {
			row.checked = event.checked;
		});
	}

	checkMultipleSelection(event, index) {
		if (event.shiftKey) {
			if (this.lastClickedIndex == null) {
				return;
			}
			event.preventDefault();
			const array = this.matData.sortData(this.matData.data, this.matData.sort);
			this.range(this.lastClickedIndex, index).forEach((iter: number) => {
				array[iter].checked = true;
			});
		}
		this.lastClickedIndex = index;
	}
	protected range(first, sec) {
		const start = Math.min(first, sec);
		const len = Math.abs(first - sec) + 1;
		return Array.from({ length: len }, (x, i) => i + start);
	}

	refreshFilter() {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	changeStatus(element) {
		if (element.swinging == 'Tak') {
			this.openStatusChange(element);
		} else {
			this.action_term = true;
			this.changeStatusApi(element, this.action_term);
		}
	}

	changeStatusApi(element, action_term) {
		if (element.status == 0) {
			this.stop_sale = true;
		} else {
			this.stop_sale = false;
		}
		this.bag.patch(
			'/transport/transport_term/' + element.id + '/',
			{
				status: element.status,
				action_term: action_term,
				stop_sale: this.stop_sale,
			},
			(item, error) => {
				if (error) {
					return;
				}
			},
		);
		element.color = this.getColor(element.status);
	}

	openStatusChange(element) {
		this.dialog
			.open(SeasonBagNewModalStatusChangeComponent, { data: element })
			.afterClosed()
			.subscribe((result) => {
				this.action_term = result.action_term;
				this.changeStatusApi(element, this.action_term);
			});
	}

	openSeasonDialog(element) {
		this.dialog.open(SeasonBagNewModalComponent, {
			data: element,
		});
	}
}
